import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    id: 0,
    fechaVigenciaDesde: moment(new Date()).format('YYYY-MM-DD'),
    fechaVigenciaHasta: moment(new Date()).format('YYYY-MM-DD'),
    semestre: 0,
    semestreNombre: null,
    anio: 0,
    semestreBase: 0,
    semestreBaseNombre: null,
    anioBase: 0,
    pjeObjetivo: 0,
    rowVersion: null,

    indicadorDatos: []
};

const mutations = {
    updateField,

    'INICIALIZAR'(state, indicadorId) {
        state.id = indicadorId;
        state.fechaVigenciaDesde = moment(new Date()).format('YYYY-MM-DD');
        state.fechaVigenciaHasta = moment(new Date()).format('YYYY-MM-DD');
        state.semestre = 0;
        state.semestreNombre = null;
        state.anio = 0;
        state.semestreBase = 0;
        state.semestreBaseNombre = null;
        state.anioBase = 0;
        state.pjeObjetivo = 0;
        state.rowVersion = null;
    },
    'SET_INDICADOR'(state, indicador) {
        state.fechaVigenciaDesde = moment(indicador.fechaVigenciaDesde).format('YYYY-MM-DD');
        state.fechaVigenciaHasta = moment(indicador.fechaVigenciaHasta).format('YYYY-MM-DD');
        state.semestre = indicador.semestre;
        state.semestreNombre = indicador.semestre == 1 ? '1er Semestre' : '2do Semestre';
        state.anio = indicador.anio;
        state.semestreBase = indicador.semestreBase;
        state.semestreBaseNombre = indicador.semestreBase == 1 ? '1er Semestre' : '2do Semestre';
        state.anioBase = indicador.anioBase;
        state.pjeObjetivo = indicador.pjeObjetivo;
        state.rowVersion = indicador.rowVersion;
    },

    'INICIALIZAR_DATOS' (state) {
        state.indicadorDatos = [];
    },
    'SET_DATOS' (state, indicadorDatos) {
        state.indicadorDatos = indicadorDatos;
    },
};

const getters = {
    getField,
};

const actions = {
    inicializar ( { commit }, indicadorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR', indicadorId);

            if (indicadorId != 0) {
                apiAxios.get('indicadores-ventas-trimestral/' + indicadorId + '/abm' ) 
                    .then(res => {
                        commit('SET_INDICADOR', res.data);
                        resolve();
                    })
                    .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
        })
    },
    save ( { state } ) {
        return new Promise((resolve, reject) => {
            if (state.semestreNombre.trim() == '1er Semestre') {
                state.semestre= 1;
            }
            if (state.semestreNombre.trim() == '2do Semestre') {
                state.semestre= 2;
            }

            if (state.semestreBaseNombre.trim() == '1er Semestre') {
                state.semestreBase= 1;
            }
            if (state.semestreBaseNombre.trim() == '2do Semestre') {
                state.semestreBase= 2;
            }

            let indicador = {
                fechaVigenciaDesde: moment(state.fechaVigenciaDesde).format('YYYY-MM-DD'),
                fechaVigenciaHasta: moment(state.fechaVigenciaHasta).format('YYYY-MM-DD'),
                semestre: parseFloat(state.semestre),
                anio: parseFloat(state.anio),
                semestreBase: parseFloat(state.semestreBase),
                anioBase: parseFloat(state.anioBase),
                pjeObjetivo: parseFloat(state.pjeObjetivo),
            }

            let url = 'indicadores-ventas-trimestral';
            if (state.id != 0) {
                url += '/' + state.id;
                indicador.rowVersion = state.rowVersion;
            }

            apiAxios.post(url, indicador)
                .then(() => resolve())
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

    getDatos ( { commit }, indicadorId ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_DATOS');

            if (indicadorId != 0) {
                apiAxios.get('indicadores-ventas-trimestral/' + indicadorId ) 
                .then(res => {
                    let datos = [
                        { 'nombre': 'anio', 'campo': 'Año', 'valor': res.data.anio, 'formato': '' },
                        { 'nombre': 'semestre', 'campo': 'Semestre', 'valor': res.data.semestre == 1 ? '1er Semestre' : '2do Semestre', 'formato': '' },
                        { 'nombre': 'anioBase', 'campo': 'Año - Base', 'valor': res.data.anioBase, 'formato': '' },
                        { 'nombre': 'semestreBase', 'campo': 'Semestre - Base', 'valor': res.data.semestreBase == 1 ? '1er Semestre' : '2do Semestre', 'formato': '' },
                        { 'nombre': 'pjeObjetivo', 'campo': 'Pje.Objetivo', 'valor': res.data.pjeObjetivo, 'formato': 'numero' },
                        { 'nombre': 'fechaVigenciaDesde', 'campo': 'Fecha Vigencia - Desde', 'valor': res.data.fechaVigenciaDesde, 'formato': 'fecha' },
                        { 'nombre': 'fechaVigenciaHasta', 'campo': 'Fecha Vigencia - Hasta', 'valor': res.data.fechaVigenciaHasta, 'formato': 'fecha' }
                    ];
                    
                    commit('SET_DATOS', datos);

                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
            } else {
                resolve();
            }
            
        })
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}